import { render, staticRenderFns } from "./Nothing.vue?vue&type=template&id=768eb661&"
import script from "./Nothing.vue?vue&type=script&lang=ts&"
export * from "./Nothing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports